import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row justify-around items-center" }
const _hoisted_2 = { class: "s-banner__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_s_icon = _resolveComponent("s-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_banner = _resolveComponent("q-banner")!

  return (_openBlock(), _createBlock(_component_q_banner, {
    dense: "",
    class: _normalizeClass(["s-banner", _ctx.type])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass({ 'col-xs-10 col-md-10 col-lg-10': _ctx.closable, 'col-xs-12': !_ctx.closable })
        }, [
          (_ctx.withIcon)
            ? (_openBlock(), _createBlock(_component_s_icon, {
                key: 0,
                class: "s-banner__icon q-pr-sm",
                name: _ctx.iconByType
              }, null, 8, ["name"]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ], 2),
        (_ctx.closable)
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 0,
              class: "col-xs-2 col-md-2 col-lg-2",
              color: "white",
              icon: "close",
              "no-wrap": "",
              flat: "",
              onClick: _ctx.close
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }, 8, ["class"]))
}